import { Order } from './Order'

export type ErrorInfo = {
  message: string
  isVisible: boolean
}

export type Group = {
  hour: number
  hoursLabel: string
  groupOrders: Order[]
  hasNewOrders: boolean
}

export type LocalSettings = {
  printingEnabled?: boolean
  automaticPrintingEnabled?: boolean
}

export type ActiveGroup = {
  title?: string
  count?: number
  hoursLabel?: string
  hour?: number
  groupOrders?: Order[]
}

export enum FilterStatus {
  Active = 'Active',
  Upcoming = 'Upcoming',
  Complete = 'Complete',
}

export enum KdsApiErrorCode {
  DeviceRevoked = 'KdsDeviceRevoked',
}
